/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlEndpointGroupDTO
 */
export interface ControlEndpointGroupDTO {
    /**
     * 
     * @type {string}
     * @memberof ControlEndpointGroupDTO
     */
    createdAt: string;
    /**
     * 
     * @type {boolean}
     * @memberof ControlEndpointGroupDTO
     */
    enabled: boolean;
    /**
     * 
     * @type {string}
     * @memberof ControlEndpointGroupDTO
     */
    endpointId: string;
    /**
     * 
     * @type {string}
     * @memberof ControlEndpointGroupDTO
     */
    group: string;
    /**
     * 
     * @type {boolean}
     * @memberof ControlEndpointGroupDTO
     */
    groupChatOpsEnabled?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ControlEndpointGroupDTO
     */
    groupContainmentEnabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ControlEndpointGroupDTO
     */
    groupId: string;
    /**
     * 
     * @type {string}
     * @memberof ControlEndpointGroupDTO
     */
    groupName?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlEndpointGroupDTO
     */
    groupRuleSearch?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlEndpointGroupDTO
     */
    groupRuleSearchField?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlEndpointGroupDTO
     */
    groupSlug?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ControlEndpointGroupDTO
     */
    groupSourceSystemUpdates?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ControlEndpointGroupDTO
     */
    id: string;
    /**
     * 
     * @type {boolean}
     * @memberof ControlEndpointGroupDTO
     */
    overriddenByUser: boolean;
    /**
     * 
     * @type {string}
     * @memberof ControlEndpointGroupDTO
     */
    overriddenByUserId?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlEndpointGroupDTO
     */
    overriddenByUserIdentifier?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlEndpointGroupDTO
     */
    teamId: string;
}

/**
 * Check if a given object implements the ControlEndpointGroupDTO interface.
 */
export function instanceOfControlEndpointGroupDTO(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "createdAt" in value;
    isInstance = isInstance && "enabled" in value;
    isInstance = isInstance && "endpointId" in value;
    isInstance = isInstance && "group" in value;
    isInstance = isInstance && "groupId" in value;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "overriddenByUser" in value;
    isInstance = isInstance && "teamId" in value;

    return isInstance;
}

export function ControlEndpointGroupDTOFromJSON(json: any): ControlEndpointGroupDTO {
    return ControlEndpointGroupDTOFromJSONTyped(json, false);
}

export function ControlEndpointGroupDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlEndpointGroupDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'createdAt': json['createdAt'],
        'enabled': json['enabled'],
        'endpointId': json['endpointId'],
        'group': json['group'],
        'groupChatOpsEnabled': !exists(json, 'groupChatOpsEnabled') ? undefined : json['groupChatOpsEnabled'],
        'groupContainmentEnabled': !exists(json, 'groupContainmentEnabled') ? undefined : json['groupContainmentEnabled'],
        'groupId': json['groupId'],
        'groupName': !exists(json, 'groupName') ? undefined : json['groupName'],
        'groupRuleSearch': !exists(json, 'groupRuleSearch') ? undefined : json['groupRuleSearch'],
        'groupRuleSearchField': !exists(json, 'groupRuleSearchField') ? undefined : json['groupRuleSearchField'],
        'groupSlug': !exists(json, 'groupSlug') ? undefined : json['groupSlug'],
        'groupSourceSystemUpdates': !exists(json, 'groupSourceSystemUpdates') ? undefined : json['groupSourceSystemUpdates'],
        'id': json['id'],
        'overriddenByUser': json['overriddenByUser'],
        'overriddenByUserId': !exists(json, 'overriddenByUserId') ? undefined : json['overriddenByUserId'],
        'overriddenByUserIdentifier': !exists(json, 'overriddenByUserIdentifier') ? undefined : json['overriddenByUserIdentifier'],
        'teamId': json['teamId'],
    };
}

export function ControlEndpointGroupDTOToJSON(value?: ControlEndpointGroupDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'createdAt': value.createdAt,
        'enabled': value.enabled,
        'endpointId': value.endpointId,
        'group': value.group,
        'groupChatOpsEnabled': value.groupChatOpsEnabled,
        'groupContainmentEnabled': value.groupContainmentEnabled,
        'groupId': value.groupId,
        'groupName': value.groupName,
        'groupRuleSearch': value.groupRuleSearch,
        'groupRuleSearchField': value.groupRuleSearchField,
        'groupSlug': value.groupSlug,
        'groupSourceSystemUpdates': value.groupSourceSystemUpdates,
        'id': value.id,
        'overriddenByUser': value.overriddenByUser,
        'overriddenByUserId': value.overriddenByUserId,
        'overriddenByUserIdentifier': value.overriddenByUserIdentifier,
        'teamId': value.teamId,
    };
}

